import React from 'react'
import PropTypes from 'prop-types'
import { Card, CardContent, Grid, Typography } from '@mui/material'
import Input from 'common/components/form/Input'
import { CardTitle } from 'common/components/card/Card'

const UserContractCard = ({
    customer = {},
    onChange = () => {},
}) => (
    <Card>
        <CardTitle title='Contrat utilisateurs' />
        <CardContent>
            <Typography variant='caption' sx={{ opacity: 0.7 }}>
                Plafonds contractuels, hors utilisateurs Aquasys. Laisser vide pour ne pas limiter.
            </Typography>
            <Grid container columnSpacing={2} rowSpacing={1} alignItems='center' sx={{ pt: 1 }}>
                <Grid size={4}>
                    <Input
                        label='Administrateurs max'
                        value={customer.maxAdmins}
                        onChange={v => onChange(c => ({ ...c, maxAdmins: v }))}
                        type='number'
                    />
                </Grid>
                <Grid size={4}>
                    <Input
                        label='Gestionnaires max'
                        value={customer.maxManagers}
                        onChange={v => onChange(c => ({ ...c, maxManagers: v }))}
                        type='number'
                    />
                </Grid>
                <Grid size={4}>
                    <Input
                        label='Connexions simultanées max'
                        value={customer.maxConcurrentConnections}
                        onChange={v => onChange(c => ({ ...c, maxConcurrentConnections: v }))}
                        type='number'
                    />
                </Grid>
            </Grid>
        </CardContent>
    </Card>
)

UserContractCard.propTypes = {
    customer: PropTypes.shape({
        maxAdmins: PropTypes.number,
        maxManagers: PropTypes.number,
        maxConcurrentConnections: PropTypes.number,
    }),
    onChange: PropTypes.func,
}

export default UserContractCard